<template>
    <div class="page-class page-prestige">
        <AIAHeader
            :modalController="modalController"
            @clickBack="clickBack" />

        <div id="profile_page" v-if="isAccountLoaded && theme == 'prestige' && isLoaded">
            <ProfileCard :lbl="lbl" :privilegeList="privilegeList" />
            <ProfilePrivilegeList
                :lbl="lbl"
                :localeCode="localeCode"
                :privilegeList="privilegeList" />
        </div>

        <AIAFootMenu
            :pageName="pageName"
            :modalController="modalController" />

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//layout
import AIAHeader from "@/components/Layout/header/AIAHeader.vue";
import AIAFootMenu from "@/components/Layout/footer/AIAFootMenu.vue";
//component
import ProfileCard from '../component/ProfileCard.vue';
import ProfilePrivilegeList from '../component/ProfilePrivilegeList.vue';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: "Profile",
    components: {
        //layout
        AIAHeader,
        AIAFootMenu,
        //component
        ProfileCard,
        ProfilePrivilegeList,
        //modal
        ModalMaster
    },
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin],
    data: function() {
        return {
            pageName: 'profile',
            isLoading: false,
            isLoaded: false,
            privilegeList: {}
        };
    },
    created: function () {
        this.initialModal();
        this.errorHandler.setAlertModal(this.alertModal);
    },
    mounted: function () {
        this.showLoading();
    },
    methods: {
        //event
        clickBack: function () {
            this.$router.back();
        },
        //initial
        accountInitiated: function () {
            if (this.tier == 'm')
                this.$router.push('/home');

            var token = this.getToken();
            Account.apiGetProfile(token)
                .then(() => {
                    this.privilegeList = Account.getCacheProfileExtensionJson();
                    this.isLoaded = true;
                    this.hideLoading();
                    console.log(this.privilegeList);
                }).catch(err => {
                    this.isLoaded = true;
                    this.hideLoading();
                    this.errorApi(err, this.errorHandler);
                });
        },
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
        },
        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#profile_page {
    padding: {
        top: 15px;
        bottom: 20px;
        left: 20px;
        right: 20px;
    };
}
</style>

